<template>
  <div class="login-wrap" :class="{ 'captcha-open': captchaVisible }">
    <div
      v-show="captchaVisible"
      class="captcha-mask"
      @click="closeCaptcha"
    ></div>
    <div class="main-block">
      <div class="login-stack">
        <div v-show="captchaVisible" id="captcha-box"></div>
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm login-container"
        @keyup.enter.native="submitForm('ruleForm')"
      >
        <h1 class="title brand-title">
          <img
            v-if="brandImageUrl"
            :src="brandImageUrl"
            :alt="brand.systemName || ''"
            :class="{ 'brand-favicon': isFaviconOnly }"
          />
          <p v-if="brand.systemName" class="system-name">{{ brand.systemName }}</p>
        </h1>
        <h3 class="title">账号登录</h3>
        <el-form-item prop="username">
          <el-input
            type="text"
            v-model="ruleForm.username"
            auto-complete="off"
            placeholder="账号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            auto-complete="off"
            placeholder="密码"
            show-password
          ></el-input>
        </el-form-item>
        <!-- <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox> -->
        <el-form-item style="width: 100%">
          <el-button
            type="primary"
            style="width: 100%"
            @click="submitForm('ruleForm')"
            :loading="logining"
            >登录</el-button
          >
        </el-form-item>
        <div class="copyright-block">{{ brand.copyright }}</div>
      </el-form>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { login } from "../api/userMG";
import { getInfo } from "../api/userMG";
export default {
  name: "login",
  data() {
    return {
      //定义loading默认为false
      logining: false,
      captchaVisible: false,
      // 记住密码
      rememberpwd: false,
      img: "",
      ruleForm: {
        //username和password默认为空
        username: "",
        password: "",
      },
      //rules前端验证
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  computed: {
    brand() {
      return this.$store.state.brand;
    },
    brandImageUrl() {
      return this.brand.logoUrl || this.brand.faviconUrl || '';
    },
    isFaviconOnly() {
      return !this.brand.logoUrl && !!this.brand.faviconUrl;
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.logining = false;
          return false;
        }
        this.logining = true;
        this.openCaptcha();
      });
    },
    hideCaptcha() {
      if (this.tac && this.tac.destroyWindow) {
        this.tac.destroyWindow();
      }
      this.tac = null;
      this.captchaVisible = false;
    },
    closeCaptcha() {
      this.hideCaptcha();
      this.logining = false;
    },
    ensureTac() {
      if (window.loadTAC) {
        return Promise.resolve();
      }
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "/static/tac/load.min.js";
        script.onload = () => resolve();
        script.onerror = () => reject();
        document.head.appendChild(script);
      });
    },
    openCaptcha() {
      this.captchaVisible = true;
      const captchaConfig = {
        requestCaptchaDataUrl: "/sys/captcha/gen",
        validCaptchaUrl: "/sys/captcha/check",
        bindEl: "#captcha-box",
        validSuccess: (res, c, tac) => {
          const token = res && res.data && res.data.token;
          this.hideCaptcha();
          if (!token) {
            this.logining = false;
            this.$message.error("验证码校验失败，请重试");
            return;
          }
          this.submitLogin(token);
        },
        validFail: (res, c, tac) => {
          const msg = (res && res.msg) || "";
          if (msg.indexOf("频繁") !== -1) {
            this.closeCaptcha();
            this.$message.error(msg);
            return;
          }
          tac.reloadCaptcha();
        },
        btnCloseFun: () => {
          this.closeCaptcha();
        },
      };
      this.$nextTick(() => {
        this.ensureTac()
          .then(() =>
            window.loadTAC("/static/tac", captchaConfig, { logoUrl: null })
          )
          .then((tac) => {
            this.tac = tac;
            tac.init();
          })
          .catch(() => {
            this.closeCaptcha();
            this.$message.error("验证码组件加载失败");
          });
      });
    },
    submitLogin(captchaToken) {
      login({
        username: this.ruleForm.username,
        password: this.ruleForm.password,
        captcha: captchaToken,
      })
        .then((res) => {
          if (res.msg == "success") {
            localStorage.setItem("logintoken", res.token);
            getInfo()
              .then((info) => {
                if (info.msg == "success") {
                  localStorage.setItem("user_info", JSON.stringify(info.data));
                  this.logining = false;
                  if (info.data.roleId == 1) {
                    this.$router
                      .push({ path: "/oms/oemBrandManage" })
                      .catch(() => {});
                  } else if (info.data.roleId == 2) {
                    this.$router
                      .push({ path: "/task/merchantList" })
                      .catch(() => {});
                  } else if (info.data.roleId == 3) {
                    this.$router
                      .push({ path: "/agent/index" })
                      .catch(() => {});
                  } else if (info.data.roleId == 4) {
                    this.$router
                      .push({ path: "/sales/index" })
                      .catch(() => {});
                  } else if (info.data.roleId == 5) {
                    this.$router
                      .push({ path: "/oms/customerSignOrder" })
                      .catch(() => {});
                  } else if (info.data.roleId == 6) {
                    this.$router
                      .push({ path: "/salesSupervisor/index" })
                      .catch(() => {});
                  } else {
                    this.$router
                      .push({ path: "/index/work" })
                      .catch(() => {});
                  }
                } else {
                  this.logining = false;
                  localStorage.removeItem("logintoken");
                  this.$message({
                    type: "error",
                    message: info.msg,
                  });
                }
              })
              .catch(() => {
                this.logining = false;
                localStorage.removeItem("logintoken");
              });
          } else {
            this.$message.error(res.msg);
            this.logining = false;
          }
        })
        .catch(() => {
          this.logining = false;
        });
    },
  },
};
</script>

<style scoped>
.login-wrap {
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: flex-end;
  background-image: url("../../src/assets/img/bg1.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  background-position: 50%;
  background-color: #d9e6ff;
  overflow: hidden;
}
.login-container {
  width: 350px;
  padding: 44px 35px 36px;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  background: hsla(0, 0%, 100%, 0.7);
  border-radius: 8px;
  border: 1px solid #fff;
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  margin-left: 20px;
}
.login-container /deep/ .el-form-item {
  margin-bottom: 26px;
}
.login-container /deep/ .el-form-item:last-of-type {
  margin-bottom: 0;
}

.main-block {
  width: 1440px;
  height: 563px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 9%;
}

.img-center {
  position: absolute;
  width: 285px;
  bottom: 497px;
  right: 45px;
}
.img-center img {
  -webkit-transform: translateX(15px);
  transform: translateX(15px);
  position: absolute;
}
.img-center img:first-child {
  top: 50px;
  right: 232px;
  animation: imgCenterDown 8s linear infinite reverse;
}
.img-center img:nth-child(2) {
  top: 58px;
  right: 211px;
  animation: imgCenterDown 8s linear infinite;
}
.img-center img:nth-child(3) {
  top: 72px;
  right: 193px;
  animation: imgCenterDown 8s linear infinite reverse;
}
@keyframes imgCenterDown {
  25% {
    -webkit-transform: translate(15px, 6px);
    transform: translate(15px, 6px);
  }

  50%,
  100% {
    -webkit-transform: translate(15px);
    transform: translate(15px);
  }
  75% {
    -webkit-transform: translate(15px, -6px);
    transform: translate(15px, -6px);
  }
}
.title {
  margin: 0 auto 28px;
  text-align: center;
  color: #505458;
}
.brand-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
}
.title img {
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 56px;
  object-fit: contain;
}
.title img.brand-favicon {
  width: 48px;
  height: 48px;
  max-height: 48px;
}
.system-name {
  margin: 12px 0 0;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  line-height: 22px;
  text-align: center;
}
.remember {
  margin: 0px 0px 35px 0px;
}
.code-box {
  text-align: right;
}
.codeimg {
  height: 40px;
}
.login-stack {
  position: relative;
}
.captcha-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  background: rgba(28, 48, 92, 0.45);
}
#captcha-box {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 2002;
  transform: translate(-50%, -50%);
}
.copyright-block {
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: #8c8c8c;
  line-height: 20px;
  text-align: center;
  margin-top: 28px;
}
</style>
<style>
#captcha-box #tianai-captcha-parent {
  width: 422px;
  height: auto;
  padding: 16px 16px 8px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #fff;
  box-shadow: 0 12px 32px rgba(36, 62, 110, 0.18);
  box-sizing: border-box;
}
#captcha-box #tianai-captcha-parent #tianai-captcha-box {
  height: 360px;
}
#captcha-box #tianai-captcha-parent #tianai-captcha-box .loading {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 2;
  width: 180px;
  height: 6px;
  margin: 0;
  border-radius: 4px;
  overflow: hidden;
  transform: translate(-50%, -50%);
  background: #e4e7ed;
  -webkit-mask: none;
  mask: none;
  animation: none;
}
#captcha-box #tianai-captcha-parent #tianai-captcha-box .loading::after {
  content: "";
  display: block;
  width: 40%;
  height: 100%;
  border-radius: 4px;
  background: #409eff;
  animation: captcha-loading 0.9s ease-in-out infinite;
}
@keyframes captcha-loading {
  0% {
    transform: translateX(-130%);
  }
  100% {
    transform: translateX(320%);
  }
}
#captcha-box #tianai-captcha.tianai-captcha-word-click {
  width: 390px;
  height: 360px;
}
#captcha-box #tianai-captcha.tianai-captcha-word-click .content {
  height: 234px;
}
#captcha-box #tianai-captcha.tianai-captcha-word-click .bg-img-div img {
  border-radius: 6px;
}
#captcha-box #tianai-captcha .content .tianai-captcha-tips {
  left: 50%;
  right: auto;
  width: max-content;
  max-width: calc(100% - 32px);
  height: 36px;
  padding: 0 18px;
  border-radius: 18px;
  font-size: 14px;
  line-height: 36px;
  letter-spacing: 1px;
  white-space: nowrap;
  transform: translate(-50%, 50%);
  box-shadow: 0 6px 16px rgba(31, 45, 61, 0.16);
}
#captcha-box #tianai-captcha .content .tianai-captcha-tips.tianai-captcha-tips-on {
  bottom: 50%;
}
#captcha-box #tianai-captcha .content .tianai-captcha-tips.tianai-captcha-tips-success {
  background: rgba(255, 255, 255, 0.96);
  color: #67c23a;
  font-size: 0;
}
#captcha-box #tianai-captcha .content .tianai-captcha-tips.tianai-captcha-tips-success::before {
  content: "验证成功";
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
}
#captcha-box #tianai-captcha .content .tianai-captcha-tips.tianai-captcha-tips-error {
  background: rgba(255, 255, 255, 0.96);
  color: #f56c6c;
}
#captcha-box #tianai-captcha.tianai-captcha-word-click .click-tip {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 56px;
  margin-bottom: 8px;
  padding: 0 4px;
  box-sizing: border-box;
}
#captcha-box #tianai-captcha.tianai-captcha-word-click .click-tip #tianai-captcha-click-track-font {
  position: static;
  flex: none;
  height: auto;
  font-size: 20px !important;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 1px;
  color: #303133;
}
#captcha-box #tianai-captcha.tianai-captcha-word-click .click-tip .tip-img {
  position: static;
  height: 48px;
  width: auto;
  max-width: 260px;
  margin-left: 12px;
  object-fit: contain;
}
#captcha-box #tianai-captcha.tianai-captcha-word-click .click-confirm-btn {
  height: 40px;
  margin-top: 12px;
  border-radius: 4px;
  background: #409eff;
  background-image: none;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 2px;
}
#captcha-box #tianai-captcha.tianai-captcha-word-click .click-confirm-btn:hover {
  background: #66b1ff;
}
#captcha-box #tianai-captcha-parent .slider-bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 32px;
  margin-top: 4px;
}
#captcha-box #tianai-captcha-parent .slider-bottom .logo {
  display: none;
}
#captcha-box #tianai-captcha-parent .slider-bottom .close-btn,
#captcha-box #tianai-captcha-parent .slider-bottom .refresh-btn {
  float: none;
  width: 28px;
  height: 28px;
  margin: 0 0 0 4px;
  border-radius: 4px;
  background: none;
  color: #909399;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
}
#captcha-box #tianai-captcha-parent .slider-bottom .refresh-btn {
  order: 1;
}
#captcha-box #tianai-captcha-parent .slider-bottom .close-btn {
  order: 2;
}
#captcha-box #tianai-captcha-parent .slider-bottom .refresh-btn::before {
  content: "↻";
}
#captcha-box #tianai-captcha-parent .slider-bottom .close-btn::before {
  content: "×";
  font-size: 22px;
}
#captcha-box #tianai-captcha-parent .slider-bottom .close-btn:hover,
#captcha-box #tianai-captcha-parent .slider-bottom .refresh-btn:hover {
  color: #409eff;
  background: #ecf5ff;
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue